import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Paper, 
  useTheme, 
  Grid,
  Button,
  alpha
} from '@mui/material';
import { 
  Email as EmailIcon,
  LocationOn as LocationIcon,
  AccessTime as TimeIcon
} from '@mui/icons-material';

const ContactPage = () => {
  const theme = useTheme();
  
  return (
    <Box sx={{ bgcolor: 'background.default' }}>
      {/* Header */}
      <Box 
        sx={{ 
          bgcolor: theme.palette.primary.main, 
          color: 'white',
          py: 6
        }}
      >
        <Container maxWidth="lg">
          <Typography 
            variant="h2" 
            component="h1" 
            gutterBottom 
            sx={{ 
              fontWeight: 700,
              textAlign: { xs: 'center', md: 'left' }
            }}
          >
            Contact Us
          </Typography>
          <Typography 
            variant="h5"
            sx={{ 
              fontWeight: 400,
              maxWidth: 800,
              textAlign: { xs: 'center', md: 'left' }
            }}
          >
            We're here to help with any questions you may have
          </Typography>
        </Container>
      </Box>

      {/* Main Content */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <Typography variant="h3" gutterBottom sx={{ fontWeight: 600 }}>
              Get In Touch
            </Typography>
            <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem' }}>
              Thank you for your interest in Seattle Market Analytics. We value your feedback and are eager to assist with any questions you might have about our platform or services.
            </Typography>
            <Typography variant="body1" sx={{ fontSize: '1.1rem', mb: 4 }}>
              The fastest way to reach our team is by email. We typically respond within 24 hours during business days.
            </Typography>
            
            <Paper 
              elevation={0} 
              sx={{ 
                p: 4, 
                borderRadius: 3,
                bgcolor: alpha(theme.palette.primary.main, 0.05),
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                mb: 4
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <EmailIcon color="primary" sx={{ mr: 2, fontSize: 28 }} />
                <Typography variant="h5" fontWeight={600}>
                  Please email us at:
                </Typography>
              </Box>
              {/* <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', mb: 2 }}>
                Please email us at:
              </Typography> */}
              <Typography 
                variant="h6" 
                component="a" 
                href="mailto:support@seattlemarketanalytics.com" 
                sx={{ 
                  color: theme.palette.primary.main,
                  fontWeight: 500,
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                support@seattlemarketanalytics.com
              </Typography>
            </Paper>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box sx={{ mt: { xs: 0, md: 8 } }}>
              <Box sx={{ mb: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <LocationIcon color="secondary" sx={{ mr: 2 }} />
                  <Typography variant="h6" fontWeight={600}>
                    Location
                  </Typography>
                </Box>
                <Typography variant="body1">
                  Seattle, Washington
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Our team works remotely throughout the Pacific Northwest
                </Typography>
              </Box>
              
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <TimeIcon color="secondary" sx={{ mr: 2 }} />
                  <Typography variant="h6" fontWeight={600}>
                    Hours
                  </Typography>
                </Box>
                <Typography variant="body1">
                  Monday - Friday: 9:00 AM - 5:00 PM PT
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  We strive to respond to all inquiries within 24 business hours
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactPage; 